export default (state, signingInState) => {
	console.info('🦑 SET_SIGN_IN_PENDING_STATE', {signingInState});
	state.auth.isSigningIn = signingInState;
};
